import React from "react";

// noinspection JSUnusedGlobalSymbols
export const ToggleSuperAdmin: React.FC = () => {
  return <></>;
};
